import { render, staticRenderFns } from "./DeckSubheader.vue?vue&type=template&id=3c1aa49c"
import script from "./DeckSubheader.vue?vue&type=script&lang=js"
export * from "./DeckSubheader.vue?vue&type=script&lang=js"
import style0 from "./DeckSubheader.vue?vue&type=style&index=0&id=3c1aa49c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports